import { IssueTaskCategory, IssueTaskStatus } from '@gooduncles/gu-app-schema';
import { message } from 'antd';
import { subMonths } from 'date-fns';
import { formatDate } from 'src/utils/date-util';
import { getIssueTasks } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const monthRange = 6;
const getIssueTasksForStore = async (storeId: string) => {
  const now = new Date();
  const end = formatDate(subMonths(now, monthRange), 'yyyy-MM-dd');

  return getIssueTasks(
    [
      ['storeId', '==', storeId],
      ['targetDate', '>=', end],
    ],
    {
      sortKey: 'targetDate',
      orderBy: 'desc',
    }
  );
};

const useIssueTasksForStore = (storeId: string | null) => {
  const { data, error, isLoading } = useSWR(
    storeId ? `issue-tasks-for-store-${storeId}` : null,
    () => (storeId ? getIssueTasksForStore(storeId) : null),
    {
      revalidateOnFocus: false,
      errorRetryCount: 2,
    }
  );
  const issueTasks = data?.filter(
    (task) => task.status === IssueTaskStatus.COMPLETED && task.category !== IssueTaskCategory.INTERNAL
  );

  if (error) {
    console.error(error);
    message.error(error.message);
  }

  return { issueTasks, issueTasksLoading: isLoading, issueTasksError: error };
};

export default useIssueTasksForStore;
